/**
 * 对象是否有属性
 * @param {*} obj
 * @param {*} key
 */
function hasOwn(obj, key) {
    return obj.hasOwnProperty(key);
}
/**
 * 是否是对象
 * @param {*} obj
 */
function isObject(obj) {
    return typeof obj === 'object' && typeof obj.length === 'undefined';
}
/**
 * 是否是字符串
 * @param {*} str
 */
function isString(str) {
    return typeof str === 'string';
}
/**
 * 是否是空对象
 * @param {*} obj
 */
function isObjectEmpty(obj) {
    let res = !obj || typeof obj === 'undefined' || (typeof obj === 'object' && obj._blank === '');
    if (!res && typeof obj === 'object') {
        const jsonStr = JSON.stringify(obj);
        if (jsonStr === '[]' || jsonStr === '{}') {
            res = true;
        }
    }
    return res;
}
/**
 * 比较版本号
 * @param {}v1
 * @param v2
 */
function compareVersion(v1, v2) {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return -1;
        }
    }
    return 0;
}
const testKey = 'testAvaiable';
/**
 * sessionStorage 是否可用
 */
function sessionStorageAvaiable() {
    let avaiable = true;
    if (typeof window !== 'undefined') {
        try {
            const storage = window.sessionStorage;
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
        }
        catch (error) {
            avaiable = false;
        }
        return avaiable;
    }
}
/**
 * localStorage 是否可用
 */
function localStorageAvaiable() {
    let avaiable = true;
    if (typeof window !== 'undefined') {
        try {
            const storage = window.localStorage;
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
        }
        catch (error) {
            avaiable = false;
        }
        return avaiable;
    }
}
/**
 * 是否是有效的域名，排除 ip 和 localhost
 */
function isValidDomain(hostname) {
    const ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    return hostname && ip.test(hostname) !== true && hostname !== 'localhost';
}
export { hasOwn, isObject, isString, isObjectEmpty, compareVersion, sessionStorageAvaiable, localStorageAvaiable, isValidDomain };
